/* ACTIONS */

import * as types from './types';

export const setViewAssociate = (data) => ({
  type: types.SET_VIEW_ASSOCIATE,
  payload: data,
});
